module.exports = __webpack_public_path__ + "static/media/leafymeat.06e01fc4.webp";